import type { ISEOProps } from "../types/core";

export const RefundPolicyPageSEO: ISEOProps = {
  title: "Refund Policy - Sugar Cribs",
  description:
    "Understand Sugar Cribs refund policy and how to request refunds for purchases and subscriptions.",
};
